export default "<div class=\"mount-point\"></div>\n\n<div class=\"rcon-loader\">\n\t<n2pc-loader></n2pc-loader>\n</div>\n"